import { render, staticRenderFns } from "./myList.vue?vue&type=template&id=6d7d46fb&scoped=true&"
import script from "./myList.vue?vue&type=script&lang=js&"
export * from "./myList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7d46fb",
  null
  
)

export default component.exports